// DepositForm.js
import React from 'react';
import ModalPayment from '../helper/modal_deposit_richiesta';
import { useTranslation } from 'react-i18next';
const DepositForm = () => {
    const { t } = useTranslation();
    return (
        <div>
            <div className="tab-content" id="myTabContent">
                <div className="tab-pane fade show active" id="Deposit-tab-pane" role="tabpanel" aria-labelledby="Deposit-tab" tabIndex="0">
                    <div className="form-online">
                        <section className="forms boxed-form">
                            <div className="form signup">
                                <div className="form-content">
                                    <h3 className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#credit-card-deposit">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800" style={{ enableBackground: 'new 0 0 800 800' }}>
                                            <path d="M593.4,666.7H206.6c-41.2,0-63.9,0-85.3-10.9c-18.9-9.6-34-24.8-43.7-43.7c-10.9-21.4-10.9-44.1-10.9-85.4V273.3
                                                c0-41.3,0-64,10.9-85.4c9.6-18.9,24.8-34,43.7-43.7c21.4-10.9,44.1-10.9,85.4-10.9h386.7c41.3,0,64,0,85.4,10.9
                                                c19,9.7,34.1,24.8,43.7,43.7c10.9,21.4,10.9,44.1,10.9,85.3v253.6c0,41.2,0,63.9-10.9,85.3c-9.6,18.9-24.8,34.1-43.7,43.7
                                                C657.3,666.7,634.6,666.7,593.4,666.7z M133.3,400v126.7c0,28.9,0,48,3.6,55.1c3.2,6.3,8.3,11.4,14.6,14.6c7.1,3.6,26.2,3.6,55,3.6
                                                h386.9c28.8,0,47.9,0,55-3.6c6.2-3.2,11.4-8.4,14.6-14.6c3.6-7.1,3.6-26.2,3.6-55V400H133.3z M133.3,266.7h533.3
                                                c0-25.2-0.3-41.9-3.6-48.5c-3.2-6.2-8.3-11.4-14.6-14.6c-7.1-3.6-26.2-3.6-55.1-3.6H206.7c-28.9,0-48,0-55.1,3.6
                                                c-6.3,3.2-11.3,8.2-14.6,14.6C133.6,224.8,133.4,241.5,133.3,266.7z M366.7,533.3H233.3c-18.4,0-33.3-14.9-33.3-33.3
                                                s14.9-33.3,33.3-33.3h133.3c18.4,0,33.3,14.9,33.3,33.3S385.1,533.3,366.7,533.3z" />
                                        </svg>
                                        {t('Credit_card')}
                                    </h3>
                                    <form action="#" id="credit-card-deposit" className="accordion-collapse collapse">
                                        <div className="row">
                                            <div className="col-12 payment-box">
                                                <label>{t('Enter_amount')}</label>
                                                <div className="input-group mt-3">
                                                <input type="text" className="form-control" placeholder={`${t('Amount')}...`} />
                                                    <span className="input-group-text" id="basic-addon2">R$</span>
                                                </div>
                                                <div className="radio2 money-radio mb-0 mt-1">
                                                    <input label="R$20" type="radio" name="data_type_change5" />
                                                    <input label="R$50" type="radio" name="data_type_change5" />
                                                    <input label="R$100" type="radio" name="data_type_change5" />
                                                    <input label="R$200" type="radio" name="data_type_change5" />
                                                    <input label="R$500" type="radio" name="data_type_change5" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="field button-field">
                                        <button type="button" data-bs-toggle="modal" data-bs-target="#card-payment">{t('Send_request')}</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </section>
                    </div>
                    
                    {/* Pix Form */}
                    <div className="form-online">
                        <section className="forms boxed-form">
                            <div className="form signup">
                                <div className="form-content">
                                    <h3 className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#pix-deposit">
                                        <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M11.917 11.71a2.046 2.046 0 0 1-1.454-.602l-2.1-2.1a.4.4 0 0 0-.551 0l-2.108 2.108a2.044 2.044 0 0 1-1.454.602h-.414l2.66 2.66c.83.83 2.177.83 3.007 0l2.667-2.668h-.253zM4.25 4.282c.55 0 1.066.214 1.454.602l2.108 2.108a.39.39 0 0 0 .552 0l2.1-2.1a2.044 2.044 0 0 1 1.453-.602h.253L9.503 1.623a2.127 2.127 0 0 0-3.007 0l-2.66 2.66h.414z"/>
                                            <path d="m14.377 6.496-1.612-1.612a.307.307 0 0 1-.114.023h-.733c-.379 0-.75.154-1.017.422l-2.1 2.1a1.005 1.005 0 0 1-1.425 0L5.268 5.32a1.448 1.448 0 0 0-1.018-.422h-.9a.306.306 0 0 1-.109-.021L1.623 6.496c-.83.83-.83 2.177 0 3.008l1.618 1.618a.305.305 0 0 1 .108-.022h.901c.38 0 .75-.153 1.018-.421L7.375 8.57a1.034 1.034 0 0 1 1.426 0l2.1 2.1c.267.268.638.421 1.017.421h.733c.04 0 .079.01.114.024l1.612-1.612c.83-.83.83-2.178 0-3.008z"/>
                                        </svg>
                                        {t('Pix')}
                                    </h3>
                                    <form action="#" id="pix-deposit" className="accordion-collapse collapse">
                                        <div className="row">
                                            <div className="col-12 payment-box">
                                            <label>{t('Enter_amount')}</label>
                                                <div className="input-group mt-3">
                                                <input type="text" className="form-control" placeholder={`${t('Amount')}...`} />
                                                    <span className="input-group-text" id="basic-addon2">R$</span>
                                                </div>
                                                <div className="radio2 money-radio mb-0 mt-1">
                                                    <input label="R$20" type="radio" name="data_type_change5" />
                                                    <input label="R$50" type="radio" name="data_type_change5" />
                                                    <input label="R$100" type="radio" name="data_type_change5" />
                                                    <input label="R$200" type="radio" name="data_type_change5" />
                                                    <input label="R$500" type="radio" name="data_type_change5" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="field button-field">
                                        <button type="button" data-bs-toggle="modal" data-bs-target="#">{t('Send_request')}</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>

                {/* Withdraw Tab */}
                <div className="tab-pane fade" id="Withdraw-tab-pane" role="tabpanel" aria-labelledby="Withdraw-tab" tabIndex="0">
                    {/*  код для Withdraw аналогічний Deposit */}
                </div>
            </div>

            {/* Модальне вікно для платежів */}
            <ModalPayment url="https://google.com/" />
        </div>
    );
};

export default DepositForm;
